import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getRelationOption, countSalaryBefore } from '@/api/personnelField';
export const validatePassword = password => {
  // 检查密码长度是否在8-20个字符之间
  if (password.length < 8 || password.length > 20) {
    return false;
  }
  // 检查密码是否包含字母和数字
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  return hasLetter && hasNumber;
};

// 身份证号码脱敏
export const handleUserIdNumber = idNumber => {
  return idNumber && idNumber.replace(/^(.{6})(?:\d+)(.{4}$)/, '$1****$2');
};

// 防抖
export const debounce = (func, wait) => {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.call(this, ...args);
    }, wait);
  };
};
export const removeLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('main_merchant_id');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('activeIndex');
  localStorage.removeItem('app_id');
  localStorage.setItem('recentlyUsed', JSON.stringify([]));
  localStorage.removeItem('breadcrumb_storage');
};

// 登录失效跳转登录页时，记录当前访问的完整地址（如 http://localhost:8080/#/recruitment/cluePackage/314?menu_id=146）
export const LOGIN_REDIRECT_URL_KEY = 'login_redirect_url';
export const saveLoginRedirectUrl = url => {
  try {
    const href = url || window.location.href;
    // 已经在登录页或首页登录入口时不需要记录
    if (href.indexOf('#/login') > -1 || href.indexOf('#/staging') > -1) return;
    localStorage.setItem(LOGIN_REDIRECT_URL_KEY, href);
  } catch (e) {
    console.log('保存跳转地址失败', e);
  }
};

// 取出记录的访问地址，返回路由部分（如 /recruitment/cluePackage/314?menu_id=146）
export const getLoginRedirectUrl = () => {
  const url = localStorage.getItem(LOGIN_REDIRECT_URL_KEY);
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.origin);
    const routePath = parsed.hash ? parsed.hash.slice(1) : parsed.pathname + parsed.search;
    if (!routePath || routePath.indexOf('/login') === 0) return '';
    return routePath;
  } catch (e) {
    return '';
  }
};
export const clearLoginRedirectUrl = () => {
  localStorage.removeItem(LOGIN_REDIRECT_URL_KEY);
};
export const deepEqual = (a, b) => {
  if (a === b) return true;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for (let key in a) {
      if (!b.hasOwnProperty(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  } else {
    return false;
  }
};
export const isInTemplate = field => {
  return field.key.split('_')?.[2] ? true : false;
};
export const currentYearMonthDay = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份是从 0 开始的，所以要加 1，同时保证两位数
  const day = String(now.getDate()).padStart(2, '0'); // 日期同样保证两位数
  return `${year}-${month}-${day}`;
};

// 下载文件
export const downloadFileFn = (url, fileName) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
// 下载文件，兼容Edge浏览器
export const downloadFileIE = async (url, filename = 'file') => {
  console.log(url, '..url');
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    // 创建下载链接
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename || 'file';

    // Edge 兼容处理
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();

    // 清理资源
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }, 100);
  } catch (error) {
    console.error('下载失败:', error);
    alert('文件下载失败，请重试');
  }
};
// 导出中心
export const ExportCenter = async (api, data) => {
  api(data).then(res => {
    if (res.code == 200) {
      ElMessageBox.confirm('导出任务已提交，请前往导出中心下载', '温馨提示', {
        type: 'warning',
        showCancelButton: false,
        showConfirmButton: false,
        showClose: false
      });
      // 3秒后自动关闭
      setTimeout(() => {
        ElMessageBox.close(false);
      }, 1000);
    }
  });
};
// 获取关联字段控件列表
export const getRelationOptionFn = async (item, formList, merchant_id) => {
  console.log(item, formList, '..item,formList');
  let parm = {
    field_id: item.id,
    field_name: item.field_name,
    select_value: item.value,
    select_id: item.value_id ?? '',
    merchant_id: merchant_id ?? localStorage.getItem('main_merchant_id')
  };
  let res = await getRelationOption(parm);
  if (res.code == 200) {
    processData(res.data, formList, 'association');
  }
};
// 处理数据
const processData = (data, formList, type) => {
  let optionlist = data;
  const optionMap = new Map(optionlist.map(item => [item.id, item]));
  for (const item of formList) {
    for (const item2 of item.fields_list) {
      const matchedOption = optionMap.get(item2.id);
      if (matchedOption) {
        if (type == 'association') {
          item2.is_visible = matchedOption.is_visible;
          item2.default_value = matchedOption.default_value;
        }
        item2.value = matchedOption.value;
      }
    }
  }
  console.log(formList, '..formList');
  return formList;
};
// 查询系统工资定级
export const countSalaryBeforeFn = async (formList, type, id, user_id, field_id) => {
  let parm = {
    value_data: formList,
    type: type,
    id: id ? id : '',
    user_id: user_id ? user_id : '',
    field_id: field_id
  };
  let res = await countSalaryBefore(parm);
  if (res.code == 200) {
    processData(res.data, formList, '');
  }
};

// 动态计算单元格宽度
const fontSize = 16; // 字体大小（px）
const padding = 30; // 单元格内边距（px）
//获取屏幕宽度
let containerWidth = Number(document.documentElement.clientWidth) - 300;
// 计算字符串宽度
const getStringWidth = (text, fontSize) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = `${fontSize}px Arial`;
  return context.measureText(text).width;
};
// 计算单元格宽度
export const WidthAdaptive = (tableHeader, tableData, operate, key = 'key', key_name = 'key_name') => {
  // 计算列总列宽
  let totalWidth = 0;
  let operateWidth = operate ? operate : 0; //右侧操作的宽度
  tableHeader.forEach(col => {
    let maxWidth = getStringWidth(col[key_name], fontSize); // 先计算表头的宽度
    tableData.forEach(row => {
      if (row[col[key]] !== undefined) {
        const contentWidth = getStringWidth(String(row[col[key]]), fontSize);
        maxWidth = Math.max(maxWidth, contentWidth); // 更新最大宽度
      }
    });
    col.width = Math.ceil(maxWidth + padding); // 加上内边距，并向上取整
    // 如果宽度大于 180，则设置为 180
    if (col.width > 180) {
      col.width = 180;
    }
    totalWidth += col.width; // 累计总宽度
  });
  // 如果总列宽小于容器宽度，调整列宽铺满屏幕
  if (totalWidth < containerWidth) {
    const extraWidth = containerWidth - totalWidth - operateWidth; // 计算剩余宽度
    const additionalWidthPerColumn = Math.floor(extraWidth / tableHeader.length); // 平均分配剩余宽度
    tableHeader.forEach(col => {
      col.width += additionalWidthPerColumn;
    });
  }
  console.log(tableHeader, '..tableHeader');
  return tableHeader;
};
// 设置搜索区域中input框的宽度
export const widthStyleFn = () => {
  return {
    width: '200px'
  };
};
export const downLoadFileFn = (url, downloadFileName) => {
  let a = document.createElement('a');
  a.href = url;
  a.download = downloadFileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
// 数据添加全部项
export const AddAllDataItems = data => {
  let obj = {
    title: '全部',
    id: 0
  };
  const foundItem = data.find(item => item.title === '全部');
  if (foundItem) {} else {
    data.unshift(obj);
  }
  return data;
};